import {IN_APP_STORAGE_KEY} from '@/lib/in-app/config'
import simpleStorage from '@/utils/simpleStorage'

export default function setIsInApp() {
  return simpleStorage.set(IN_APP_STORAGE_KEY, true)
}
